export default "__VITE_ASSET__JeDUqsDP__"